<template>
  <div class="tableau" v-if="ticket != '-1' && ticket" :style="{ zoom: getZoom }">
    <Tableau
      :height="height"
      :width="width"
      :url="url"
      ref="effectivenessTableau"
    >
    </Tableau>
  </div>
  <div v-else-if="ticket == '-1'">
	  <error-section></error-section>
	</div>
  <div v-else>
	</div>
</template>

<script>
import dashboardApi from '@/api/dashboard/index';
import { mapGetters } from 'vuex';
import moment from 'moment';
import Tableau from '../../../common/tableau/Tableau.vue';
import { getZoom } from '../../../../utils';
import global_var from '@/global/global';
import ErrorSection from '../error/ErrorSection.vue';

export default {
  components: { Tableau, ErrorSection },
  data() {
    return {
      ticket: "",
      tableauWidth: "100%",
      enterTime: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    getZoom,
    url() {
      return `${global_var.DASHBOARD_URL}/trusted/${this.ticket}/${global_var.DASHBOARD_SCORE_URL}?adAccount=${this.userInfo.username}`;
    },
  },
  methods: {
    resizeTableau() {
      // this.tableauWidth = document.getElementsByClassName('tableau')[0].clientWidth - 10 + 'px';
    },
  },
  mounted() {
    const width = window.screen.width / getZoom();
    const height = window.screen.height / getZoom();
    this.width = width;
    this.height = height;
    dashboardApi.getTableauTicket().then((result) => {
      this.ticket = result;
      this.$nextTick(() => {
        this.$refs.effectivenessTableau.initViz();
      });
    });
    window.addEventListener("resize", this.resizeTableau);
    this.$nextTick(() => {
      this.resizeTableau();
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeTableau);
    dashboardApi
      .saveStayTime({
        enterTime: this.enterTime,
        leaveTime: moment().format("YYYY-MM-DD HH:mm:ss"),
        description: "仪表盘-评分",
      })
      .then(() => {});
  },
};
</script>

<style lang="less" scoped>
.tableau {
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// index.vue?9e6cff92